import { render, staticRenderFns } from "./PermissionConfig.vue?vue&type=template&id=ff059adc&scoped=true&"
import script from "./PermissionConfig.vue?vue&type=script&lang=js&"
export * from "./PermissionConfig.vue?vue&type=script&lang=js&"
import style0 from "./PermissionConfig.vue?vue&type=style&index=0&id=ff059adc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff059adc",
  null
  
)

export default component.exports